import {Grid} from '@mui/material';
import {arrayOf} from 'prop-types';

import {BREAKPOINTS} from '../../const';
import Project from './single-project-item/Project';
import useBreakpoint from '../../hooks/dom/useBreakpoint';
import {projectShape} from '../../proptypes-shapes';

const ConnectionsGrid = ({connections}) => {
  const breakpoint = useBreakpoint();
  const spacing = breakpoint === BREAKPOINTS.xs ? 0 : 2;
  const px = breakpoint === BREAKPOINTS.xs ? 2 : 0;

  return (
    <Grid px={px} mt={2} container spacing={spacing} justifyContent="center" alignItems="stretch">
      {connections.map((project, index) => (
        <Grid key={index} item xs={12} md={6} lg={4} display="flex">
          <Project project={project} />
        </Grid>
      ))}
    </Grid>
  );
};

ConnectionsGrid.propTypes = {
  connections: arrayOf(projectShape).isRequired
};

export default ConnectionsGrid;
